module.exports = __webpack_public_path__ + "img/ms.ad88044d.svg";